/**
 * Site brand name for the header, footer and browser tab title.
 *
 * The site displays under a single unified brand: "Travel Sports Info LLC".
 *
 * The current sport is read from `SportContext`, which is kept in sync by the
 * Landing page whenever the user changes the sport filter.
 */
import { useSport } from "@/context/SportContext";

export const BASKETBALL_BRAND = "Travel Sports Info LLC";
export const OTHER_SPORTS_BRAND = "Travel Sports Info LLC";

export function brandNameForSport(sport) {
    return sport === "Basketball" ? BASKETBALL_BRAND : OTHER_SPORTS_BRAND;
}

/** Returns the site brand string: "Travel Sports Info LLC". */
export function useBrandName() {
    const { sport } = useSport();
    return brandNameForSport(sport);
}
